<template>
  <div class="dt-details2">
    <div class="dt-details--header" v-if="invoice">
      <div class="title" :title="invoice && invoice.full_name">
        {{ invoice.full_name }}
      </div>
    </div>
    <div class="dt-details--body">
      <div class="dt-details--col">
        <div class="invoice-subject">
          {{ status_text ||$t('cost_name') }}
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("net_amount") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && invoice.invoice_date"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{ $dft.curr(selectedCostsDetails.invoice.net_amount) }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
        <div
          v-if="
            selectedCostsDetails.invoice.vat1_amount !== '0.00' &&
            vat_handling !== 3
          "
          class="dt-details--row"
        >
          <div class="dt-details--label">{{ $t("vat1_amount") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && $dft.curr(invoice.amount)"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{ $dft.curr(selectedCostsDetails.invoice.vat1_amount) }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
        <div
          v-if="
            selectedCostsDetails.invoice.vat2_amount !== '0.00' &&
            vat_handling !== 3
          "
          class="dt-details--row"
        >
          <div class="dt-details--label">{{ $t("vat2_amount") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && $dft.curr(invoice.amount)"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{ $dft.curr(selectedCostsDetails.invoice.vat2_amount) }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
        <div
          v-if="
            selectedCostsDetails.invoice.tax_deduction_amount !== '0.00' &&
            vat_handling == 3
          "
          class="dt-details--row"
        >
          <div class="dt-details--label">{{ $t("taxes") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && $dft.curr(invoice.amount)"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{
                $dft.curr(
                  selectedCostsDetails.invoice.tax_deduction_amount,
                  this.selectedCostsDetails.invoiceCurrency.currency_iso
                )
              }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
        <div v-if="showExchange" class="dt-details--row">
          <div class="dt-details--label">{{ $t("exchange_rate") }}</div>
          <div class="dt-details--value" :title="exchangeRate" v-if="invoice">
            <div v-if="!selectedCostsDetails.loading">
              {{ exchangeRate }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("gross_amount") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && invoice.gross_amount"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading" style="font-weight: 700">
              {{ $dft.curr(invoice.gross_amount) }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div>
        <!-- <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("total_payments") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && $dft.curr(invoice.total_payments)"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{ $dft.curr(selectedCostsDetails.payment_total) }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            
            </div>
          </div>
        </div> -->
        <!--  <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("open_amount") }}</div>
          <div :title="invoice && $dft.curr(invoice.amount)" v-if="invoice">
            <div
              v-if="
                !selectedCostsDetails.loading &&
                selectedCostsDetails.invoiceBackground == '505050'
              "
              style="
                border-radius: 10px;
                width: max-content;
                padding: 1px 8px;
                position: absolute;
                right: 61px;
              "
              :style="{
                color: '#ffffff',
                backgroundColor: `#${selectedCostsDetails.invoiceBackground}`,
              }"
            >
              {{
                $dft.curr(
                  selectedCostsDetails.invoice.gross_amount -
                    selectedCostsDetails.payment_total
                )
              }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
            <div
              v-else-if="
                !selectedCostsDetails.loading &&
                selectedCostsDetails.invoiceBackground != '505050'
              "
              style="
                border-radius: 10px;
                width: max-content;
                padding: 1px 8px;
                position: absolute;
                right: 61px;
              "
              :style="{
                backgroundColor: `#${selectedCostsDetails.invoiceBackground}`,
              }"
            >
              {{
                $dft.curr(
                  selectedCostsDetails.invoice.gross_amount -
                    selectedCostsDetails.payment_total
                )
              }}
              {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
            </div>
          </div>
        </div> -->
        <div v-if="showExchange" class="dt-details--row">
          <div class="dt-details--label">{{ $t("net_system_curr") }}</div>
          <div
            class="dt-details--value"
            :title="invoice && $dft.curr(invoice.exchange_rate)"
            v-if="invoice"
          >
            <div v-if="!selectedCostsDetails.loading">
              {{
                $dft.curr(
                  selectedCostsDetails.invoice.net_amount /
                    selectedCostsDetails.invoice.exchange_rate,
                  $store.getters.account.client.default_currency
                )
              }}
              {{ $store.getters.account.client.default_currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvoiceStatusColor } from "../../models/color-status";
export default {
  props: {
    selectedCostsDetails: {
      type: Object,
    },
  },
  methods: {
    getInvoiceStatusColor: getInvoiceStatusColor,
  },
  computed: {
    exchangeRate() {
      return (
        (this.selectedCostsDetails &&
          this.selectedCostsDetails.invoice &&
          this.selectedCostsDetails.invoice.exchange_rate &&
          this.selectedCostsDetails.invoice.exchange_rate.toFixed(6)) ||
        ""
      );
    },
    invoice: function () {
      console.log("INVOICE", this.selectedCostsDetails);
      return this.selectedCostsDetails ? this.selectedCostsDetails.invoice : {};
    },
    vat_handling: function () {
      return this.selectedCostsDetails?.invoice?.vat_handling;
    },
    showExchange: function () {
      return (
        this.selectedCostsDetails?.invoiceCurrency?.currency_iso !==
        this.$store.getters.account.client.default_currency
      );
    },
    status_text: function () {
      return this.invoice?.invoice_project_name &&
        this.invoice?.invoice_ref &&
        this.invoice?.currency_iso
        ? `${this.invoice.invoice_project_name}/${this.invoice.invoice_date}/${this.invoice.currency_iso}/${this.invoice.external_ref}/${this.invoice.invoice_ref}`
        : this.invoice?.invoice_project_name && this.invoice?.currency_iso
        ? `${this.invoice.invoice_project_name}/${this.invoice.invoice_date}/${this.invoice.currency_iso}/${this.invoice.external_ref}`
        : this.invoice?.invoice_project_name
        ? `${this.invoice.invoice_project_name}/${this.invoice.invoice_date}/${this.invoice.external_ref}`
        : "";
    },
    getVatAmount: function () {
      if (this.invoice.vat_handling == 1 || this.invoice.vat_handling == 2) {
        return (
          +this.invoice.vat1_amount + +this.invoice.vat2_amount || 0
        ).toFixed(2);
        // } else if (this.invoice.tax_type_id_deduction) {
        //   return (+this.invoice.tax_deduction_amount).toFixed(2);
      } else {
        return (0).toFixed(2);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-details--value {
  display: flex;
  justify-content: flex-end;
  padding: 0px 2px 0px 2px;
}
.invoice-subject {
  height: 65px;
  overflow: hidden;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
</style>
